export default (value) => {
  if (!value || isNaN(value)) return '-'
  let num = value
  if (value[0] === '0' && value[1] === '0') num = value.substring(2)
  let ddd = null
  let numero1 = null
  let numero2 = null
  if (num.length === 10) {
    ddd = num.substring(0, 2)
    numero1 = num.substring(2, 6)
    numero2 = num.substring(6, 10)
  } else if (num.length === 11) {
    ddd = num.substring(0, 2)
    numero1 = num.substring(2, 7)
    numero2 = num.substring(7, 11)
  } else if (num.length === 12) {
    ddd = num.substring(2, 4)
    numero1 = num.substring(4, 8)
    numero2 = num.substring(8, 12)
  } else if (num.length === 13) {
    ddd = num.substring(2, 4)
    numero1 = num.substring(4, 9)
    numero2 = num.substring(9, 13)
  }
  if (ddd && numero1 && numero2) return `(${ddd}) ${numero1}-${numero2}`
  else return value
}
